<template>
  <div class="mcard row mx-0">
    <product-tags-edit
            :change_tags="change_tags"
            :checked="checked"
            :default_tags="item.tags"
            :default_labels="item.labels"
            @success="changeLabels($event)">
    </product-tags-edit>
    <div class="col-12 col-md-5 p-0">
      <CoolLightBox
          :items="slides"
          :index="index"
          @close="index = null">
      </CoolLightBox>
      <div style="overflow: hidden">
        <vueper-slides fixed-height="265px" :bullets="false" class="no-shadow" :duration="250" :touchable="false">
          <template v-slot:arrow-left>
            <img src="../../assets/icons/arrow-left.svg" class="arrow">
          </template>
          <template v-slot:arrow-right>
            <img src="../../assets/icons/arrow-right.svg" class="arrow">
          </template>
          <vueper-slide v-for="({src}, i) in slides" :key="i" :image="src" @click.native="open(i)"/>
        </vueper-slides>
        <div v-if="item.labels.length > 0"  class="notice-area">
          <div class="notice" v-for="(label, index) in item.labels" :key="index">
              {{label}}
          </div>
          <!--<div class="notice">
            Акция
          </div>-->
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 p-0">
      <div class="mcard__main m-0">
        <div class="sub-title">Артикул производителя: {{item.article}}</div>
        <div class="title">{{item.name}}</div>
        <div class="main-grid">
          <div class="d-flex align-items-center mb-13">
            <span class="amount cg tbold">
              {{item.price_opt | currency}} ₽
            </span>
            <!--<span class="sub-amount">
              4 300 ₽
            </span>-->
          </div>
          <!--<div class="d-flex align-items-center mb-13">
            <span class="rating-text tbold co">4,6</span>
            <div class="rating-stars d-flex align-items-center">
              <img src="../../assets/icons/star-orange.svg" v-for="a in 4" :key="'r'+a"/>
              <img src="../../assets/icons/star-grey.svg"/>
            </div>
            <span class="count-ratings">(32)</span>
          </div>-->
          <!--<div class="counter">
            <div class="counter__item">
              <img src="../../assets/icons/minus.svg" alt="">
            </div>
            <div class="counter__item">
              <span>
                34
              </span>
            </div>
            <div class="counter__item">
              <img src="../../assets/icons/plus.svg" alt="">
            </div>
          </div>
          <div>
            <button class="big-btn">
              Добавить к заказу
            </button>
          </div>-->
          <div class="stock-text d-flex flex-column justify-content-center">
            <div class="quantity-block">На моем складе: <span class="co tbold ml-1">{{item.quantity}}</span></div>
            <!--<div>У поставщика: <span class="cg tbold ml-3">40</span></div>-->
          </div>
        </div>
        <br><br>
        <button class="big-btn" @click="change_tags = !change_tags">
          Присвоить статус
        </button>
        <!--<div class="actions d-flex align-items-center">
          <button class="action">
            <img src="../../assets/icons/like.svg">
            В избранное
          </button>
          <button class="action">
            <img src="../../assets/icons/comparison.svg">
            Сравнить
          </button>
          <button class="action">
            <img src="../../assets/icons/clock.svg">
            Аналитика
          </button>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ProductTagsEdit from "@/components/product-tags-edit";
export default {
  name: "item-card",
  components: { VueperSlides, VueperSlide, ProductTagsEdit},
  data: ()=> ({
    index: null,
    slides: [],
    change_tags: false,
    checked: []
  }),
  props: {
    item: null
  },
  mounted () {
    for(let index in this.item.images) {
      this.slides.push({'src': this.item.images[index].image});
    }

    this.checked[this.item.id] = 1;
  },
  methods: {
    open(i){
      this.index = i
    },
    changeLabels(val) {
      this.change_tags = false;
      this.item.labels = val.labels;
      if (val.tags) {
        this.item.tags = val.tags.split(',');
      } else {
        this.item.tags = [];
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .quantity-block {
    width: 200px;
  }

  .slider{
    background-color: white;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #EEF0F3;
    height: 265px;

    .controls{
      padding-left: 15px;
      padding-right: 15px;
      position: absolute;
      top:50%;
      margin-top: calc(-20px/2);
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    img{
      width: 203px;
      height: 203px;
    }

    img.arrow {
      width: 18px;
      height: 20px;
    }

  }

  .notice-area{
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    top: 3px;
    right: 3px;
    font-family: 'Roboto';
    font-size: 11px;
    line-height: 13px;
    z-index: 1;

    .notice{
      width: max-content;
      margin-top: 2px;
      color: white;
      border-radius: 4px;
      padding: 7px 5px;
      background: #F39220;
    }
    .notice:first-child{
      margin-top: unset;
    }

  }

  .mb-13{
    margin-bottom: 5px;
  }

  .big-btn{
    width: 100%;
    height: 100%;
    max-width: 188px;
    padding: 10px 10px;
    border: unset;
    outline: unset;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 26px;
    color: white;
    background-color: #2CB181;
    border-radius: 4px;
  }

  .mcard__main {
    font-family: 'Roboto';
    font-size: 11px;
    line-height: 13px;
    padding: 30px;

    .sub-title{
      color: #B6BCC8;
    }
    .title {
      max-width: 300px;
      font-size: 16px;
      line-height: 19px;
    }

    .main-grid{
      grid-gap: 5px;
      margin-top: 5px;
      display: grid;
      grid-template-columns: 130px 150px;

      .amount {
        font-size: 18px;
        line-height: 21px;
        margin-right: 5px;
      }

      .sub-amount{
        font-size: 12px;
        line-height: 14px;
        text-decoration-line: line-through;
        color: #B6BCC8;
      }

      .rating-text{
        font-size: 16px;
        line-height: 19px;
      }

      .rating-stars {
        margin: 0 4px;
      }

      .count-ratings{
        font-size: 10px;
        line-height: 12px;
        color: #7A818F;
      }

      .type-select{
        display: flex;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px #E5E5EA;
        border-radius: 4px;
        padding: 3px;
        align-items: center;

        &__item {
          cursor: pointer;
          text-align: center;
          width: 100%;
        }

        .selected {
          background: #EEF0F3;
          border-radius: 4px;
          padding: 6px 10px;
        }
      }

      .stock-text{
        color: #7A818F;
        font-size: 12px;
        line-height: 16px;
      }

      .counter{
        background: #EEF0F3;
        border-radius: 4px;
        display: flex;
        justify-content: center;



        &__item{
          position: relative;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #2D3137;
          }
        }
        &__item:after{
          border-left: 1px solid #D5D9E0;
          content: " ";
          position: absolute;
          top: 35%;
          right: 0;
          height: 30%;
          margin-top: auto;
          margin-bottom: auto;
        }
        &__item:last-child:after{
          border-left: unset;
        }
      }
    }

    .actions {
      margin-top: 16px;

      .action{
        margin-right: 10px;
        border: unset;
        background: transparent;
        outline: unset;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img{
          margin-right: 5px;
          width: 15px;
          height: 15px;
        }
      }
    }
  }
</style>
